// src/store/reducer.js
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface InagarTypeData {
    nagar_type: number;
}
const initialState: InagarTypeData = {
    nagar_type: 0
  };
  
  const Dashboard =createSlice({
    name: "nagar_type",
    initialState,
    reducers: {
        setNagarType: (state, _action: PayloadAction<InagarTypeData>) => {
            state.nagar_type = _action.payload.nagar_type;
        }
    }
  });
  export const { setNagarType  } = Dashboard.actions;

export default Dashboard.reducer;
  